<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md>
        <b-card>
          <div slot="header">
            <strong>Therapist Preferences</strong>
          </div>
		  <b-row>
			  <b-col lg>
				<b-form-group
				label="Therapist"
				label-for="search_therapist"
				:label-cols="1"
				description="Select a Therapist"
				inline
				
				>
					<b-input-group size="sm">
						<b-input-group-prepend is-text><i class="fa fa-users" aria-hidden></i></b-input-group-prepend>
						<b-form-input list="active_therapists-list" v-model="search_therapist"></b-form-input>
						<b-form-datalist id="active_therapists-list" :options="active_therapists" value-field="id" text-field="name"></b-form-datalist>
						<!--<b-form-select id="search_therapist" v-model="search_therapist"  :options="therapistoptions"></b-form-select>-->
						
					</b-input-group>
				</b-form-group>
			  </b-col>
		  </b-row>
		  <b-row>
			  <b-col md>
			  <b-form-group
				label="Home Zip Code"
				label-for="therapist_home_zip_code"
				:label-cols="1"
				description="Specify the home zip code for the Therapist"
				inline
				
				>
					<b-input-group size="sm">
						<b-input-group-prepend is-text><i class="fa fa-home" aria-hidden></i></b-input-group-prepend>
						<b-form-input id="therapist_home_zip_code" list="active_zips-list" v-model="therapist_home_zip"></b-form-input>
						<b-form-datalist id="active_zips-list" :options="active_zips" text-field="name"></b-form-datalist>
					</b-input-group>
				</b-form-group>
			</b-col>
          </b-row>
		  <b-row>
			  Therapist Region Preferences
          </b-row>
        </b-card>
      </b-col>
	</b-row>
  </div>
</template>

<script>
export default {
  name: 'forms',
  data () {
    return {
	  search_therapist: null,
	  therapist_home_zip: "",
	  active_therapists: [],
	  active_zips: [],
	  
    }
  },
  methods: {
	getActiveTherapists() {
		let $this = this
		$this.therapistoptions = [{value:"",text:"Loading",disabled:true}]
		$this.search_therapist = ""
		return this.$http.post('/activetherapists', { })
		.then(function(r) {
			//console.log(r);
			$this.active_therapists = r.data
			$this.therapistoptions = [{value:"",text:"Please select",disabled:true}]
			r.data.forEach(function (row) {
				$this.therapistoptions.push({value:row.id, text:row.name})
			});

			return;
		})
		.catch(function() { 
			return [ {id:"",name:"Oops, sometehing went wrong."}] 
		})
	},

	getActiveZips() {
		let $this = this
		return this.$http.post('/activezips', { })
		.then(function(r) {
			//console.log(r);
			$this.active_zips = r.data
			return;
		})
		.catch(function() { 
			return [ {id:"",name:"Oops, sometehing went wrong."}] 
		})
	},

	getTherapistZipPreferences() {

	}
  },
  beforeMount(){
		this.getActiveTherapists()
		this.getActiveZips()
  },
  watch: {
	  search_therapist: function() {
		  if(this.search_therapist.length > 0) {
			  this.getTherapistZipPreferences();
		  } else {
			// nothing to do
		  }
	  },

	  active_therapist: function(v, old) {

	  }
  },
}
</script>